var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReserveBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#DEE8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16.3327V24.666C27.5 27.166 26.25 28.8327 23.3333 28.8327H16.6667C13.75 28.8327 12.5 27.166 12.5 24.666V16.3327C12.5 13.8327 13.75 12.166 16.6667 12.166H23.3333C26.25 12.166 27.5 13.8327 27.5 16.3327Z",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.083 14.25V15.9167C22.083 16.8333 22.833 17.5833 23.7497 17.5833H25.4163",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 21.334H20.0003",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.667 24.666H23.3337",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReserveBox);
export default __webpack_public_path__ + "static/media/ReserveBox.bc6ab2617782ed4b3788672d9085f565.svg";
export { ForwardRef as ReactComponent };